import { isAboveAndOnShape, } from '../../_pure/contractHelpers/itemHelpers.js';
const LABEL_CHANNELS = ['aboveItem', 'onItem', 'backItem'];
function hostsChannel(channel, shape) {
    return channel === 'aboveItem' || isAboveAndOnShape(shape);
}
/**
 * Whether an item declares a channel is the item's decision; when a declared channel shows is the
 * constellation's. Policy entries for channels the shape does not host are inert.
 */
export function resolveVisibleLabelChannels(args) {
    const { item, itemParametricState, shape, labelChannelPolicy, activeItemKey, hoveredItemKey } = args;
    return LABEL_CHANNELS.filter((channel) => {
        if (itemParametricState.label?.[channel] === undefined)
            return false;
        if (!hostsChannel(channel, shape))
            return false;
        const condition = labelChannelPolicy?.[channel] ?? 'always';
        if (condition === 'never')
            return false;
        if (condition === 'active')
            return activeItemKey === item.itemKey;
        if (condition === 'hover')
            return hoveredItemKey === item.itemKey;
        return true;
    });
}
